import { SortingState, flexRender } from "@tanstack/react-table";
import { FC } from "react";
import { cx } from "shared/utils";
import { ArrowUp } from "untitledui-js-base";

type Props = {
  headerGroup: any;
  hasSubheader?: boolean;
  thClassName?: string;
  sortableKeys?: string[];
  //hack need to refactor
  sorted?: { key: string; desc: boolean } | SortingState;
  setSorted?: ((prev: { key: string; desc: boolean }) => void) | any;
};

export const TableHeader: FC<Props> = ({
  headerGroup,
  hasSubheader,
  thClassName,
  sortableKeys,
  sorted,
  setSorted
}) => {
  return (
    <thead>
      {!hasSubheader ? (
        <tr>
          {headerGroup[0].headers.map((header, idx) => (
            <th
              key={`headerGroup_${headerGroup[0].id}_header_${header.id}_${idx}`}
              style={{
                borderBottom: "1px solid rgba(28, 29, 34, 0.04)",
                minWidth:
                  header.getSize() && !isNaN(header.getSize())
                    ? header.getSize()
                    : undefined
              }}
              className={cx(
                "h-12 max-h-12 min-h-12 px-1 xl:px-4 py-3",
                thClassName
              )}
            >
              <HeaderContent
                header={header}
                isSortable={sortableKeys?.includes(
                  String(header.column.columnDef.id)
                )}
                handleSort={() => {
                  const currentId = header.column.columnDef.id;

                  if (Array.isArray(sorted))
                    setSorted((prev) => {
                      const filtered = prev.filter((el) => el.id !== currentId);

                      return [
                        ...filtered,
                        {
                          id: sortableKeys?.filter((el) =>
                            currentId.includes(el)
                          )[0],
                          desc:
                            !prev.filter((el) => el.id === currentId)?.[0]
                              ?.desc || false
                        }
                      ];
                    });
                  else
                    setSorted((prev) => ({
                      key: currentId,
                      desc: !prev.desc
                    }));
                }}
                sortDirection={sorted}
              />
            </th>
          ))}
        </tr>
      ) : (
        headerGroup.map((group, groupIndex) => (
          <tr key={`headerGroup_${group.id}_${groupIndex}`}>
            {group.headers.map((header, idx) => (
              <th
                key={`headerGroup_${group.id}_header_${header.id}_${idx}`}
                style={{
                  borderBottom: "1px solid rgba(28, 29, 34, 0.04)",
                  minWidth:
                    header.getSize() && !isNaN(header.getSize())
                      ? header.getSize()
                      : undefined
                }}
                className={cx("h-12 max-h-12 min-h-12 px-4 py-3", thClassName)}
              >
                <HeaderContent
                  header={header}
                  isSortable={sortableKeys?.includes(
                    String(header.column.columnDef.id)
                  )}
                  handleSort={() => {
                    const currentId = header.column.columnDef.id;

                    if (Array.isArray(sorted))
                      setSorted((prev) => {
                        const filtered = prev.filter(
                          (el) => el.id !== currentId
                        );

                        return [
                          ...filtered,
                          {
                            id: sortableKeys?.filter((el) =>
                              currentId.includes(el)
                            )[0],
                            desc:
                              !prev.filter((el) => el.id === currentId)?.[0]
                                ?.desc || false
                          }
                        ];
                      });
                    else
                      setSorted((prev) => ({
                        key: currentId,
                        desc: !prev.desc
                      }));
                  }}
                  sortDirection={sorted}
                />
              </th>
            ))}
          </tr>
        ))
      )}
    </thead>
  );
};

const HeaderContent = ({
  isSortable,
  handleSort,
  header,
  sortDirection
}: {
  isSortable?: boolean;
  handleSort: () => void;
  header: any;
  //hack need to refactor
  sortDirection?: { key: string; desc: boolean } | SortingState;
}) => {
  return (
    <div
      onClick={() => {
        if (isSortable) handleSort();
      }}
      className={cx(
        "cursor-pointer flex items-center gap-1 group",
        header.id.includes("right-align") ? "justify-end" : "justify-start"
      )}
    >
      <p className="m-0 text-xs font-medium text-content-300">
        {flexRender(header.column.columnDef.header, header.getContext())}
      </p>
      {isSortable && (
        <ArrowUp
          size="16"
          className={cx(
            "stroke-content-300 transition-rotate group-hover:visible shrink-0",
            Array.isArray(sortDirection)
              ? sortDirection.filter((el) =>
                  header.column.columnDef.id.includes(el.id)
                )[0]?.desc
                ? "rotate-180"
                : "rotate-0"
              : sortDirection?.desc
                ? "rotate-180"
                : "rotate-0"
          )}
        />
      )}
    </div>
  );
};
